import { BookOpen, CalendarClock, ClipboardCheck, FilePlus2, ListPlus, PenLine } from 'lucide-react';
import type { router as AppRouter } from '../../router';
import { registerCommands, type Command } from '../../shell/command-registry';

/**
 * S17's palette entries (06-qol §1: every screen registers itself). "Assessments" itself
 * comes from the module bar; these are its pages and the things made there. S18 adds
 * exam sessions (ASM-04) and marking (ASM-06), each behind its own §L23 object.
 */
export function registerAssessmentCommands(router: typeof AppRouter): () => void {
  const commands: Command[] = [
    {
      id: 'assessments.tests',
      label: 'Tests',
      section: 'navigate',
      context: 'Assessments · ASM-02',
      permission: 'assessment_template',
      icon: ClipboardCheck,
      keywords: ['test', 'assessment', 'exam', 'builder'],
      run: () => void router.navigate({ to: '/assessments' }),
    },
    {
      id: 'assessments.bank',
      label: 'Question bank',
      section: 'navigate',
      context: 'Assessments · ASM-01',
      permission: 'assessment_template',
      icon: BookOpen,
      keywords: ['question', 'bank', 'multiple choice', 'mcq', 'assessment'],
      run: () => void router.navigate({ to: '/assessments/questions' }),
    },
    {
      id: 'assessments.sessions',
      label: 'Exam sessions',
      section: 'navigate',
      context: 'Assessments · ASM-04',
      permission: 'exam_session',
      icon: CalendarClock,
      keywords: ['exam', 'session', 'invigilator', 'roster', 'attendance', 'on paper'],
      run: () => void router.navigate({ to: '/assessments/sessions' }),
    },
    {
      id: 'assessments.marking',
      label: 'Marking',
      section: 'navigate',
      context: 'Assessments · ASM-06',
      permission: 'assessment_attempt',
      icon: PenLine,
      keywords: ['mark', 'grade', 'grading', 'written answers', 'queue'],
      run: () => void router.navigate({ to: '/assessments/marking' }),
    },
    {
      id: 'assessments.new-test',
      label: 'New test',
      section: 'action',
      context: 'Assessments',
      permission: 'assessment_template',
      icon: FilePlus2,
      keywords: ['create', 'build', 'test', 'assessment'],
      run: () => void router.navigate({ to: '/assessments/tests/$testId', params: { testId: 'new' } }),
    },
    {
      id: 'assessments.new-question',
      label: 'New question',
      section: 'action',
      context: 'Assessments · question bank',
      permission: 'assessment_template',
      icon: ListPlus,
      keywords: ['create', 'add', 'question', 'bank'],
      run: () => void router.navigate({ to: '/assessments/questions', search: { edit: 'new' } }),
    },
  ];
  return registerCommands(commands);
}
